import { Navigate } from "react-router-dom"
import {
  ApiKeysPage,
  ApiRequestsPage,
  CreateAccountPage,
  LoginPage,
  SettingsPage,
  ForgotPasswordPage,
} from "../components"

export const UNPROTECTED_ROUTES = [
  {
    path: "/login",
    El: <LoginPage />,
    layoutProps: {
      showNavbarArt: false,
      navBackground: true,
    },
  },
  {
    path: "/forgot-password",
    El: <ForgotPasswordPage />,
    layoutProps: {
      showNavbarArt: false,
      navBackground: true,
    },
  },
]

export const PROTECTED_ROUTES_ORGANIZATION = [
  {
    path: "/settings",
    El: <SettingsPage />,
  },
  {
    path: "/api-keys",
    El: <ApiKeysPage />,
  },
  {
    path: "/api-requests",
    El: <ApiRequestsPage />,
  },
  {
    path: "*",
    El: <Navigate to={"/"} />,
  },
]

export const CREATE_ACCOUNT_ROUTES = [
  {
    path: "/create-account",
    El: <CreateAccountPage />,
  },
]
